import { CopilotPanelContentBase, CopilotPanelContext } from './copilotBridge';

/**
 * The copilot content of the project scene: the project the user has open, and the room inside it
 * when one is open. Its ready-made questions are answered by the general agent, which resolves the
 * subject from the entity ref this usage hands it.
 *
 * Names and counts only, and only facts that are already recorded: an unsaved decision in a room
 * draft is not part of the record and never reaches the model.
 */
export class CopilotProjectsContent extends CopilotPanelContentBase {
  public readonly context = CopilotPanelContext.Projects;

  projectId: number;

  projectName: string;

  /** The names of the project's frameworks, as the norm cache holds them. */
  standardNames: string[];

  /** The room the user has open. Undefined on the project surfaces (overview, milestone, step). */
  roomKey?: string;

  roomName?: string;

  /** The milestone the current surface hangs under, by name. */
  milestoneName?: string;

  /** The room's anchor task. With it the agent resolves "this room" through the task itself. */
  deliverableTaskId?: number;

  /** The page route the actions of this content are bound to. */
  route: string;

  constructor(projectId: number, projectName: string, standardNames: string[], route: string) {
    super();

    this.projectId = projectId;
    this.projectName = projectName;
    this.standardNames = standardNames;
    this.route = route;
  }
}
